// React imports
import React from "react";

// Material imports
import { Typography } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import PropTypes from "prop-types";
// Icon imports
import ErrorIcon from "@material-ui/icons/Error";

let ErrorMessage = props => {
  const styles = {
    error: {
      backgroundColor: "#D32E2F",
      color: "#ffffff"
    },
    icon: {
      fontSize: 20,
      marginRight: 10,
      color: "#ffffff"
    },
    message: {
      display: "flex",
      alignItems: "center"
    },
    errorText: {
      color: "#ffffff",
      whiteSpace: "pre-line"
    }
  };
  return (
    <Snackbar open={props.open} onClose={props.onClose} autoHideDuration={7000}>
      <SnackbarContent
        style={styles.error}
        aria-describedby="error-snackbar"
        message={
          <span id="error-snackbar" style={styles.message}>
            <ErrorIcon style={styles.icon} />
            {props.errorMessage &&
              props.errorMessage
                .split(",")
                .map(item => (
                  <Typography style={styles.errorText}>
                    {props.translate(item)}
                  </Typography>
                ))}
          </span>
        }
      />
    </Snackbar>
  );
};

ErrorMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  translate: PropTypes.func.isRequired
};

export default ErrorMessage;
